const specialCharactersMap = {
  amperRe_: /&/g,
  ltRe_: /</g,
  gtRe_: />/g,
  quotRe_: /"/g,
  singleQuotRe_: /'/g,
  allRe_: /[&<>"']/
};
export default ((str, defintelyContainsHTML) => {
  if (str === null || str === undefined) {
    return '';
  }
  if (defintelyContainsHTML) {
    return str.replace(specialCharactersMap.amperRe_, '&amp;').replace(specialCharactersMap.ltRe_, '&lt;').replace(specialCharactersMap.gtRe_, '&gt;').replace(specialCharactersMap.quotRe_, '&quot;').replace(specialCharactersMap.singleQuotRe_, '&#x27;');
  } else {
    if (!specialCharactersMap.allRe_.test(str)) {
      return str;
    }
    if (str.indexOf('&') !== -1) {
      str = str.replace(specialCharactersMap.amperRe_, '&amp;');
    }
    if (str.indexOf('<') !== -1) {
      str = str.replace(specialCharactersMap.ltRe_, '&lt;');
    }
    if (str.indexOf('>') !== -1) {
      str = str.replace(specialCharactersMap.gtRe_, '&gt;');
    }
    if (str.indexOf('"') !== -1) {
      str = str.replace(specialCharactersMap.quotRe_, '&quot;');
    }
    if (str.indexOf("'") !== -1) {
      str = str.replace(specialCharactersMap.singleQuotRe_, '&#x27;');
    }
    return str;
  }
});